<osp-icon iconSize="xLarge" [icon]="IconKey.GlobalClose | icon" />
